import { call, put } from 'redux-saga/effects';
import {toast} from "react-toastify";

export function* handleApiRequest(action, apiFunction, successAction, failureAction) {
    try {
        const response = yield call(apiFunction, action.payload || {});
        if (response.error) {
            toast(response.error);
            yield put(failureAction(response));
        } else {
            if (response.msg) {
                toast(response.msg);
            }
            yield put(successAction(response));
        }
    } catch (e) {
        toast(e.message);
    }
}
